export const validateRequired = (value: string) => !!value.length;
export const validateEmail = (email: string) =>
  !!email.length && email.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
export const validateAge = (age: number) => age >= 18 && age <= 50;
export const validateComany = (id: number) => !!id;
export const validateHours = (hours: string) => {
  const [hour, minute] = hours.split(':');
  return parseInt(hour) >= 0 && parseInt(hour) <= 23 && parseInt(minute) >= 0 && parseInt(minute) <= 59;
};
